import { humanize } from 'web-shared/utils';

export type HttpErrorDetail =
  | string
  | number
  | boolean
  | null
  | undefined
  | HttpErrorDetail[]
  | { [key: string]: HttpErrorDetail };

export const isErrorGroup = (errors: HttpErrorDetail): errors is HttpErrorDetail[] | { [key: string]: HttpErrorDetail } =>
  errors !== null && typeof errors === 'object';

export const isIndexKey = (key: string) => /^\d+$/.test(key);

/** Backend reports collection errors by zero-based index, shown as `Supervisors #1` instead of a bare `0` */
export const getErrorEntryLabel = (key: string, parentLabel?: string) => {
  if (!isIndexKey(key)) return humanize(key);

  const position = `#${Number(key) + 1}`;

  return parentLabel ? `${parentLabel} ${position}` : position;
};

export const hasVisibleErrors = (errors: HttpErrorDetail, message?: string): boolean => {
  if (errors === null || errors === undefined || errors === '') return false;
  if (typeof errors === 'string') return errors !== message;
  if (Array.isArray(errors)) return errors.some(error => hasVisibleErrors(error, message));
  if (typeof errors === 'object') return Object.values(errors).some(error => hasVisibleErrors(error, message));
  return true;
};

/** Returns text for entries rendered in one row with their label, `null` for entries requiring a nested block */
export const getInlineErrorText = (errors: HttpErrorDetail, message?: string) => {
  if (!isErrorGroup(errors)) return String(errors);
  if (!Array.isArray(errors) || errors.some(isErrorGroup)) return null;

  return errors
    .filter(error => hasVisibleErrors(error, message))
    .join(', ');
};
